export enum DataSourceInputType {
  Api = "Api", // API Key Sync, OAuth Sync, Blockchain Sync
  Csv = "Csv", // Platform specific File Import
  Custom = "Custom", // Custom File Import
}
